import { render } from "./PlanUpsellCart.vue?vue&type=template&id=713b80c9&scoped=true"
import script from "./PlanUpsellCart.vue?vue&type=script&lang=js"
export * from "./PlanUpsellCart.vue?vue&type=script&lang=js"

import "./PlanUpsellCart.vue?vue&type=style&index=0&id=713b80c9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713b80c9"]])

export default __exports__